import React, { Component } from "react";
import { Route } from "react-router-dom";
import { connect } from "react-redux";
import _ from "lodash";
import {
  Row,
  Col,
  PopoverHeader,
  PopoverBody,
  Popover,
  OverlayTrigger,
  Tooltip,
  DropdownButton,
  Dropdown,
  ProgressBar,
} from "react-bootstrap";
import { createStore, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
import { loadingBarMiddleware } from "react-redux-loading-bar";
import reduxReset from "redux-reset";
import Button from "react-bootstrap-button-loader";
import { Provider } from "react-redux";
import { confirmAlert } from "react-confirm-alert";
import IFrame from "react-iframe";
import { CopyToClipboard } from "react-copy-to-clipboard";

import LocaleStrings from "Languages";
import MenuIcon from "MenuIcon";
import General from "DashboardGeneral";
import Content from "DashboardContent";
import Branding from "DashboardBranding";
import Activity from "DashboardActivity";
import Analytics from "Analytics";
import Publish from "Publish";
import Settings from "Settings";
import Accountsettings from "AccountSettings";
import Supportchat from "Supportchat"; // Import Support chat from webpack
import Templates from "Templates";
import Notification from "Notification";
import Profile from "HeaderProfile";
import HeaderSettings from "HeaderSettings";
import Message from "HeaderMessage";
import Users from "Users";
import DashboardOutreach from "DashboardOutreach";
import AdminPanelDashboardStatus from "AdminPanelDashboardStatus";
import FeaturesPage from "FeaturesPage";
import FileUpload from "./components/upload/file-upload";
import Tickets from "Tickets";
import Polls from "Polls";
import Gamification from "Gamification";
import EventChooser from "EventChooser";
import Courses from "Courses";
import UserlimitExpired from "Userlimitexpired";
import {
  COMMON_FAIL_MESSAGE,
  isTablet,
  DEVELOPMENT_TYPE,
  BASE_IMAGES_URL,
  converDateIntoLocalDate,
  DOMAIN_NAME,
} from "Constants";
import {
  selectDashboardMenu,
  updateUnsavedChanges,
  updateProcessing,
  selectedRevealMenuIcon,
  fetchUnreadcount,
} from "DashboardMenuAction";
import {
  logout,
  openEventChooser,
  initiateCreateEvent,
  fetchAllRelatedEvents,
  createEventInsideDashboard,
  openCloneOptions,
  checkClientExpiryDate,
  markLogin,
  getDeviceSize,
} from "Actions";
import {
  fetchScheduleDates,
  dateRangeUpdate,
  patchEventDetails,
  patchFeatures,
  fetchFeature,
  checkContentDashboardStatus,
  resetAppmodules,
} from "GeneralTabAction";
import {
  uploadBrandingData,
  fetchBranding,
  fetchBrandingEmpty,
  updateEmailtemplateswiththemecolor,
} from "BrandingAction";
import { fetchEvent, fetchLoggedinuser } from "ActionsMessage";
import { checkTicketDaschoardStatus } from "TicketAction";
import {
  fetchadminissueTokenOpen,
  fetchtotalaccountusageofclient,
  fetchClientalldetails,
} from "AccountSettingsAction";
import { errorBarMiddleware } from "ReduxErrorBar";
import { showError, showSuccess } from "ReduxErrorBar";
import ErrorBar from "ReduxErrorBar";
import reducers from "../../reducers";
import { loadState, saveState } from "../../localStorage";

import EventClone from "../clone/index";
import ReportIssue from "ReportIssue";
import BetaFeature from "BetaFeature";

var persistedState = loadState();
var createStoreWithMiddleware = compose(
  applyMiddleware(thunk, loadingBarMiddleware(), errorBarMiddleware()),
  reduxReset()
)(createStore);
export var store = createStoreWithMiddleware(reducers, persistedState);
store.subscribe(() => {
  saveState(store.getState());
});

class Dashboard extends Component {
  constructor(props) {
    super(props);

    this.onProfileClick = this.onProfileClick.bind(this);
    this.onSettingsClick = this.onSettingsClick.bind(this);
    this.onNotificationClick = this.onNotificationClick.bind(this);
    this.onMessageClick = this.onMessageClick.bind(this);
    this.onLogoutClicked = this.onLogoutClicked.bind(this);

    this.state = {
      loading: false,
      loadingSave: false,
      redirection: false,
      redirectionPath: "",
      action: "",
      currenteventId: null,
      expired: false,
      shareCopied: false,
    };

    this.interval = null;

    this.generalRef = React.createRef();
    this.brandingRef = React.createRef();
    this.featureRef = React.createRef();
    this.publishPop = React.createRef();
    this.eventInfoPop = React.createRef();
    this.mobilePreviewPop = React.createRef();
    this.progressPreviewPop = React.createRef();
    this.adminStatus = React.createRef();
  }

  componentWillMount() {
    let { isLoggedIn, user, session } = this.props;
    // console.log("dashboard isLoggedIn :- ", isLoggedIn);
    // console.log("dashboard will user :- ", user);
    // console.log("dashboard will session :- ", session);

    if (isLoggedIn === false) {
      // console.log("1");
      this.props.history.push("/login");
    } else if (isLoggedIn === true) {
      if (user.hasOwnProperty("totalAdminEvents")) {
        if (user.totalAdminEvents == 0) {
          // console.log("2");
          this.props.fetchAllRelatedEvents(user, session);
          this.props.history.push("/dashboard/accountsettings/billings");
        } else if (user.totalAdminEvents > 0) {
          // Only call if admin is having an event
          // console.log("3");
          // Fetch the content app tabs..
          if (session.eventid) {
            this.props.fetchEvent(session);
            this.props.fetchFeature(session);
            this.props.checkTicketDaschoardStatus(session);
            this.props.checkContentDashboardStatus(session);
          }
          this.props.fetchAllRelatedEvents(user, session);
          this.props.fetchBrandingEmpty(session);
        } else {
          // console.log("r");
          this.props.history.push("/dashboard/accountsettings/billings");
        }
      } else {
        this.props.logout(this.props.session);
      }
    }
  }

  componentWillUnmount() {
    //debugger
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.createEventFromDashboard && nextProps.isLoggedIn) {
      this.props.createEventInsideDashboard(false);
      this.props.history.push("/");
    }

    if (!nextProps.createEventFromDashboard && !nextProps.isLoggedIn) {
      this.props.history.push("/login");
    }

    if (this.state.currenteventId !== nextProps.session.eventid) {
      this.setState({ currenteventId: nextProps.session.eventid });
    }
  }

  componentDidMount() {
    let { user, session } = this.props;
    // console.log("dashboard did user :- ", user);
    // console.log("dashboard did session :- ", session);

    this.props.getDeviceSize();
    this.props.fetchLoggedinuser(session);
    this.props.fetchadminissueTokenOpen(session, user.clientid);
    if (session.eventid) {
      this.props.checkClientExpiryDate(
        session.eventid,
        this.props.session,
        (response) => {
          if (response.success == 1) {
          } else {
            if (user && user.isSuperAdmin) {
              var menuItem = {
                iconName: LocaleStrings.accountsetting_header_title,
                description: LocaleStrings.accountsetting_header_subtitle,
                bsClass: "accountsettings",
              };
              this.props.selectDashboardMenu(menuItem);
              this.props.markLogin(); // Mark login as true
              this.props.openEventChooser({ showModal: false });
              this.props.initiateCreateEvent({ initiate: false });
              this.props.history.push("/dashboard/accountsettings/billings");
              this.props.resetAppmodules();
              this.props.showError(LocaleStrings.login_user_session_expired);
            }
          }
        }
      );
    }
    if (!this.interval) {
      //debugger
      // this.interval = setInterval(() => {
      //   let values = {
      //     eventid: this.state.currenteventId,
      //     requesttype: "fetchunread",
      //     admin: 1,
      //   };
      //   this.props.fetchUnreadcount(
      //     this.props.session,
      //     values,
      //     (callback) => {}
      //   );
      // }, 10000);
    }
  }

  renderLogoMenuIcon() {
    var menuIcon = { iconName: "", bsClass: "Logo", description: "" };
    return <MenuIcon key="StaticIcon" menuItem={menuIcon} />;
  }

  renderMenuIcons() {
    // This code is used to programmatically merge user with ticket and disable or enable ticket side menu as per conditions.
    // in loop we have not displaying user side menu as it moved inside the ticket
    let mergeDisable = false;
    let blankArray = [{ isenabled: true }];

    let userMenu =
      this.props.totalAppModules.length > 0
        ? _.filter(this.props.totalAppModules, (obj) => {
            return obj.bsClass === "users";
          })
        : blankArray;
    let ticketMenu =
      this.props.totalAppModules.length > 0
        ? _.filter(this.props.totalAppModules, (obj) => {
            return obj.bsClass === "tickets";
          })
        : blankArray;

    if (userMenu[0].isenabled || ticketMenu[0].isenabled) {
      mergeDisable = true;
    }
    // =============================== //

    return _.map(this.props.totalAppModules, (menuIcon) => {
      if (
        (menuIcon.alwaysavailable ||
          menuIcon.isenabled ||
          (menuIcon.bsClass === "tickets" && mergeDisable)) &&
        menuIcon.bsClass !== "users" &&
        menuIcon.bsClass !== "proposal" &&
        menuIcon.section !== "only_content_module"
        // && menuIcon.bsClass !== "support" // Support added in sidemenu
      ) {
        return (
          <MenuIcon
            key={menuIcon.bsClass}
            menuItem={menuIcon}
            onClickNext={this.goNextWithoutRedirection}
          />
        );
      }
    });
  }

  onSettingsClick() {
    this.props.history.push("/dashboard/hsettings");
  }

  onProfileClick() {
    this.props.history.push("/dashboard/profile");
  }

  onNotificationClick() {
    this.props.history.push("/dashboard/notification");
  }

  onMessageClick() {
    this.props.history.push("/dashboard/message");
  }

  onLogoutClicked() {
    confirmAlert({
      title: LocaleStrings.button_logout,
      message: `${LocaleStrings.logout_want_to_logout}?`,
      confirmLabel: LocaleStrings.button_yes,
      cancelLabel: LocaleStrings.button_no,
      // onConfirm: () => {
      //   clearInterval(this.interval); // Clear Interval
      //   this.interval = null;
      //   //debugger
      //   setTimeout(() => {
      //     this.props.logout(this.props.session);
      //   }, 0);
      // },
      // onCancel: () => {},
      buttons: [
        {
          label: LocaleStrings.button_yes,
          onClick: () => {
            this.interval = null;
            //debugger
            setTimeout(() => {
              this.props.logout(this.props.session);
            }, 0);
          },
        },
        {
          label: LocaleStrings.button_no,
          onClick: () => {},
        },
      ],
    });
  }

  onSettingsClicked() {
    var menuItem = {
      iconName: "Settings",
      description: "Change your current password to new one.",
      bsClass: "settings",
    };
    this.props.selectDashboardMenu(menuItem);
    this.props.history.push("/dashboard/settings/passwordsetting");
    this.closeprogressPreviewPop();
  }

  onAccountSettingsClicked() {
    var menuItem = {
      iconName: LocaleStrings.accountsetting_header_title,
      description: LocaleStrings.accountsetting_header_subtitle,
      bsClass: "accountsettings",
    };
    this.props.selectDashboardMenu(menuItem);
    this.props.history.push("/dashboard/accountsettings/billings");
    this.closeprogressPreviewPop();
  }

  /*** SUPPORT CHAT ICON CLICK OPEN FUNCTION  ***/
  onSupportChatIconClicked() {
    var menuItem = {
      iconName: LocaleStrings.accountsetting_header_title,
      description: LocaleStrings.accountsetting_header_subtitle,
      bsClass: "accountsettings",
    };
    this.props.selectDashboardMenu(menuItem);
    this.props.history.push("/dashboard/accountsettings/reportissue");
  }

  resetStates = () => {
    this.setState({ loading: false, loadingSave: false, action: "" });
  };

  submitSettingsCallback = (values) => {
    if (this.state.action === "next") {
      this.setState({ loading: true });
    } else if (this.state.action === "save") {
      this.setState({ loadingSave: true });
    }
    this.props.updateProcessing(true);
    var session = this.props.session;
    var data;

    // Below code is commented by Vinay on 26-02-2020 as now we are using tinymce editor to save description and in tinymce this code does not required.

    data = { ...values };

    this.props.patchEventDetails(
      session,
      data,
      (result) => {
        this.props.updateUnsavedChanges(false);
        this.resetStates();
        this.props.updateProcessing(false);
        this.props.fetchAllRelatedEvents(this.props.user, this.props.session);

        if (this.state.redirection) {
          this.props.history.push("/dashboard/features");
          //this.props.showSuccess('Event details updated successfully!');
        } else {
          if (this.state.redirectionPath !== "")
            this.props.history.push(this.state.redirectionPath);
        }
      },
      (error) => {
        this.props.showError(COMMON_FAIL_MESSAGE);
        this.resetStates();
        this.props.updateProcessing(false);
      }
    );
  };

  submitBrandingDataCallback = (values) => {
    let { session, currentEventData } = this.props;
    let source = values.source ? values.source : ""; // appbranding,appmenu,splash
    let previousthemcolor = currentEventData["themecolor"];
    // console.log('previousthemcolor',previousthemcolor);

    setTimeout(() => {
      // This setTimeout is used to handle the action state, coz according to that button loading activated and setState is executing in another function
      if (this.state.action === "next") {
        this.setState({ loading: true });
      } else if (this.state.action === "save") {
        this.setState({ loadingSave: true });
      }
      this.props.updateProcessing(true);
      this.props.uploadBrandingData(
        session,
        values,
        (result) => {
          if (source === "appbranding") {
            this.props.updateEmailtemplateswiththemecolor(
              session,
              previousthemcolor
            );
          }
          if (source === "appbranding" || source === "splash") {
            this.props.fetchBranding(session);
          }
          if (source === "appmenu") {
            this.props.fetchFeature(session);
          }

          // this.props.fetchAllRelatedEvents(this.props.user, this.props.session);  // this call is commented by Vinay (01/02/2023) as its not requered here.

          this.props.updateUnsavedChanges(false);
          this.resetStates();
          this.props.updateProcessing(false);

          if (this.state.redirection) {
            this.props.history.push("/dashboard/content");
            //this.props.showSuccess('Branding details updated successfully!');
          } else {
            if (this.state.redirectionPath !== "")
              this.props.history.push(this.state.redirectionPath);
          }
        },
        (error) => {
          this.props.showError(COMMON_FAIL_MESSAGE);
          this.resetStates();
          this.props.updateProcessing(false);
        }
      );
    }, 500);
  };

  submitFeaturesDataCallback = (values, appBottomMenu) => {
    // debugger;
    var session = this.props.session;
    if (values.length === 0) {
      this.props.showError("Select at least one feature");
    } else {
      setTimeout(() => {
        // This setTimeout is used to handle the action state, coz according to that button loading activated and setState is executing in another function
        if (this.state.action === "next") {
          this.setState({ loading: true });
        } else if (this.state.action === "save") {
          this.setState({ loadingSave: true });
        }
        this.props.updateProcessing(true);
        this.props.patchFeatures(
          session,
          { newFeatures: values, bottomMenu: appBottomMenu },
          true,
          (response) => {
            this.props.fetchFeature(session, (response) => {
              //this.props.showSuccess("Features updated successfully");
              this.props.updateUnsavedChanges(false);
              this.resetStates();
              this.props.updateProcessing(false);

              if (this.state.redirection) {
                this.props.history.push("/dashboard/branding");
              } else {
                if (this.state.redirectionPath !== "")
                  this.props.history.push(this.state.redirectionPath);
              }
            });
          },
          (error) => {
            this.props.showError(COMMON_FAIL_MESSAGE);
            this.resetStates();
            this.props.updateProcessing(false);
          }
        );
      }, 500);
    }
  };

  onlySave = (e) => {
    this.goNextWithoutRedirection("");
  };

  goNextWithoutRedirection = (path) => {
    this.setState({ action: "save" });
    if (path !== "") {
      this.setState({ redirectionPath: path });
      this.processNext(false, path);
    } else {
      this.processNext(false, "samepage");
    }
  };

  goNext = () => {
    this.setState({ action: "next" });
    this.processNext(true, "gotonext");
  };

  processNext = (redirection, path = "") => {
    var { menuIcons, currentPage } = this.props;

    // handling only click to save or save & next without any changes.
    if (
      (currentPage && currentPage !== "" && path === "gotonext") ||
      path === "samepage"
    ) {
      var currentIndex = _.findIndex(menuIcons, (obj) => {
        return obj.bsClass === currentPage;
      });
      var currentMenu = menuIcons[currentIndex];

      if (path === "gotonext") {
        currentMenu = menuIcons[currentIndex + 1];
      }
      this.props.selectDashboardMenu(currentMenu);
    }

    this.setState({ redirection });
    //if redirection is true clicking next with redirect to next screen
    // var currentPage=this.props.currentPage;

    if (currentPage === "general") {
      if (this.props.unsavedChanges) {
        //Submit General

        this.generalRef.current.submit();
      } else {
        if (redirection) this.props.history.push("/dashboard/features");

        this.props.updateProcessing(false);
        this.resetStates();
      }
    } else if (currentPage === "branding") {
      if (this.props.unsavedChanges) {
        //Submit Branding

        // this settimeout section is added to to display loading the save button earlier as this.brandingRef.current.submit() method taking some time to get the data.
        setTimeout(() => {
          if (this.state.action === "next") {
            this.setState({ loading: true });
          } else if (this.state.action === "save") {
            this.setState({ loadingSave: true });
          }
          this.props.updateProcessing(true);
        }, 200);

        this.brandingRef.current.submit();
      } else {
        if (redirection) this.props.history.push("/dashboard/content");

        this.props.updateProcessing(false);
        this.resetStates();
      }
    } else if (currentPage === "features") {
      if (this.props.unsavedChanges) {
        //Submit General

        this.featureRef.current.submit();
      } else {
        if (redirection) this.props.history.push("/dashboard/branding");

        this.props.updateProcessing(false);
        this.resetStates();
      }
    }
  };

  closeAdminStatuaPopover = () => {
    // this.refs.adminStatus.hide();
    document.body.click();
  };

  closePublishPopover = () => {
    // this.refs.publishPop.hide();
    document.body.click();
  };

  closeEventInfo = () => {
    // this.refs.eventInfoPop.hide();
    document.body.click();
  };

  closemobilePreview = () => {
    // this.refs.mobilePreviewPop.hide();
    document.body.click();
  };

  closeprogressPreviewPop = () => {
    // this.refs.progressPreviewPop.hide();
    document.body.click();
  };

  adminPanelStatus = () => {
    var width = window.innerWidth;

    let className = "admin-dashboard-popover-big-screen";
    if (width === 1024) {
      className = "admin-dashboard-popover-1024-screen";
    } else if (width === 1280) {
      className = "admin-dashboard-popover-1280-screen";
    } else if (width === 1366) {
      className = "admin-dashboard-popover-1366-screen";
    } else if (width === 1440) {
      className = "admin-dashboard-popover-1440-screen";
    }

    return (
      <Popover
        title="Admin Panel Status"
        id="popover-basic"
        className={className}
        style={{ maxWidth: 700, width: 700, height: 690 }}>
        <button
          type="button"
          className="close btn-sm btn-publish-close"
          onClick={this.closeAdminStatuaPopover}
          style={{ marginTop: -35, marginRight: 10 }}>
          <span aria-hidden="true">&times;</span>
        </button>
        <Provider store={store}>
          <AdminPanelDashboardStatus
            history={this.props.history}
            session={this.props.session}
          />
        </Provider>
      </Popover>
    );
  };

  publishPopover = () => {
    var width = window.innerWidth;

    let className = "publish-popover-big-screen";
    if (width === 1024) {
      className = "publish-popover-1024-screen";
    } else if (width === 1280) {
      className = "publish-popover-1280-screen";
    } else if (width === 1366) {
      className = "publish-popover-1366-screen";
    } else if (width === 1440) {
      className = "publish-popover-1440-screen";
    }

    return (
      <Popover
        title="Upgrade your plan"
        id="popover-basic-preview"
        className="event-info-popover"
        style={{ maxWidth: 1000, width: 1000, height: 630 }}>
        <button
          type="button"
          className="close btn-sm btn-publish-close"
          onClick={this.closePublishPopover}
          style={{ marginTop: -35, marginRight: 10 }}>
          <span aria-hidden="true">&times;</span>
        </button>
        <Provider store={store}>
          <Publish />
        </Provider>
      </Popover>
    );
  };

  basicEventInfo = () => {
    var { currentEventData } = this.props;
    let className = "event-info-popover";

    return (
      <Popover
        title={LocaleStrings.event_basic_info}
        id="popover-basic-preview"
        className={className}>
        <PopoverHeader>
          <h3 className="popover-title">{LocaleStrings.event_basic_info}</h3>
        </PopoverHeader>

        <PopoverBody>
          <div className="popover-content">
            <button
              type="button"
              className="i-custom-cross-popover pull-right"
              onClick={this.closeEventInfo}>
              <img
                className="i-custom-small"
                src="../../style/images/custom-icons/cross-black.png"
                alt="cross-black"
              />
            </button>

            <div
              className="dashboard-preview"
              style={{ paddingTop: 0, height: "unset" }}>
              <div className="event-info-sections">
                <span className="custom-text1-secondary-normal">
                  {LocaleStrings.eventgroup} :{" "}
                </span>
                <span className="custom-text1-primary-medium">
                  {currentEventData && currentEventData.group_number
                    ? currentEventData.group_number
                    : ""}
                </span>
              </div>
              <div className="event-info-sections">
                <span className="custom-text1-secondary-normal">
                  {LocaleStrings.eventcode} :{" "}
                </span>
                <span className="custom-text1-primary-medium">
                  {currentEventData && currentEventData.eventcode
                    ? currentEventData.eventcode
                    : ""}
                </span>
              </div>
              <div className="event-info-sections">
                <span className="custom-text1-secondary-normal">
                  {LocaleStrings.eventid} :{" "}
                </span>
                <span className="custom-text1-primary-medium">
                  {currentEventData && currentEventData.eventid
                    ? currentEventData.eventid
                    : ""}
                </span>
              </div>
              <div className="event-info-sections">
                <span className="custom-text1-secondary-normal">
                  {LocaleStrings.general_form_label_event_name} :{" "}
                </span>
                <span className="custom-text1-primary-medium">
                  {currentEventData && currentEventData.eventname
                    ? currentEventData.eventname
                    : ""}
                </span>
              </div>
              <div className="event-info-sections">
                <span className="custom-text1-secondary-normal">
                  {LocaleStrings.general_form_label_event_validity} :{" "}
                </span>
                <span className="custom-text1-primary-medium">
                  {currentEventData && currentEventData.clients_by_clientidfk
                    ? converDateIntoLocalDate(
                        currentEventData.clients_by_clientidfk.validupto
                      )
                    : ""}
                </span>
              </div>
            </div>
          </div>
        </PopoverBody>
      </Popover>
    );
  };

  copyUrl = () => {
    this.setState({ shareCopied: true });

    setTimeout(() => {
      this.setState({ shareCopied: false });
    }, 500);
  };

  mobilePreview = () => {
    var { currentEventData } = this.props;
    let className = "mobile-preview-popover";

    let promo_share_url = `https://${
      currentEventData ? currentEventData.seocode : ""
    }.${DOMAIN_NAME}/share`;

    return (
      <Popover
        title={LocaleStrings.preview}
        id="popover-basic-preview-mobile"
        className={className}>
        <PopoverHeader
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}>
          <h3 className="popover-title">
            {LocaleStrings.promo_overview_modal_header}
          </h3>

          <button
            type="button"
            className="i-custom-cross-popover-mobile"
            onClick={this.closemobilePreview}>
            {/* <span aria-hidden="true">&times;</span> */}
            <img
              className="i-custom-small"
              src="../../style/images/custom-icons/cross-black.png"
              alt="cross-black"
            />
          </button>
        </PopoverHeader>

        <PopoverBody>
          <div className="popover-content">
            <div
              className="dashboard-preview"
              // style={{ paddingTop: 0, height: "unset" }}
            >
              {/* --- Copy share page link --- */}
              <div className="ticket-dashboard-ticket-created-page-main-div">
                <h4 className="heading-para">
                  {LocaleStrings.promo_overview_copy_title}
                </h4>
                <p className="promote-para">
                  {LocaleStrings.promo_overview_copy_subtitle}
                </p>
                <div className="vertical-align-center gap-2">
                  <div className="">
                    <div
                      className="copy-ticket-page copyticketab"
                      style={{ width: 508 }}>
                      <div className="ticket-url">{promo_share_url}</div>
                      <CopyToClipboard
                        text={promo_share_url}
                        onCopy={this.copyUrl}>
                        <div
                          className="url-copy"
                          style={{ padding: "10px 34px" }}>
                          <i
                            className="fa fa-files-o i-custom-m"
                            aria-hidden="true"></i>
                          {this.state.shareCopied ? (
                            <>
                              <span style={{ color: "green" }}>
                                {LocaleStrings.copied}
                              </span>
                            </>
                          ) : (
                            <>
                              <span>{LocaleStrings.button_copy}</span>
                            </>
                          )}
                        </div>
                      </CopyToClipboard>
                    </div>
                  </div>
                  <div className="">
                    <a
                      href={promo_share_url}
                      target="blank"
                      className="btn btn-custom-blue">
                      <span aria-hidden="true">
                        {LocaleStrings.button_visit}
                      </span>
                    </a>
                  </div>
                </div>
              </div>

              {/* --- Page embeded --- */}
              <IFrame
                url={promo_share_url}
                width="768px"
                height="500px"
                id="webbrowser"
                display="initial"
                position="relative"
              />
            </div>
          </div>
        </PopoverBody>
      </Popover>
    );
  };

  progressPreview = () => {
    // var { currentEventData } = this.props;

    let className = "progress-preview-popover";

    let {
      totalAppModules,
      contentDashboard,
      availableFeatures,
      ticketDashboard,
    } = this.props;

    let content = true;
    _.map(availableFeatures, (feature) => {
      if (feature.isenabled) {
        if (contentDashboard && !contentDashboard[feature.bsClass]) {
          content = false;
        }
      }
    });

    let branding = true;
    if (ticketDashboard !== undefined && ticketDashboard.branding === false) {
      branding = false;
    }
    let setting = true;
    if (ticketDashboard !== undefined && ticketDashboard.setting === false) {
      setting = false;
    }
    let paymentgateway = true;
    if (
      ticketDashboard !== undefined &&
      ticketDashboard.paymentgateway === false
    ) {
      paymentgateway = false;
    }

    var enabledTicket = _.filter(totalAppModules, {
      bsClass: "tickets",
      isenabled: true,
    });

    return (
      <Popover
        title="Lets Get Your Setup"
        id="popover-basic-preview-progress"
        className={className}>
        <PopoverHeader>
          <h3 className="popover-title">Let's Get Your Setup</h3>
          <span className="checklist-subtext">
            {" "}
            Get the most out of Eventify by following this simple setup steps.
          </span>
        </PopoverHeader>

        <PopoverBody>
          <button
            type="button"
            className="i-custom-cross-popover pull-right"
            onClick={this.closeprogressPreviewPop}>
            {/* <span aria-hidden="true">&times;</span> */}
            <img
              className="i-custom-small"
              src="../../style/images/custom-icons/cross-black.png"
              alt="cross"
            />
          </button>
          {/* <div className="checklist-subtext">
            Get the most out of Eventify by following this simple setup steps.
          </div> */}
          <div
            className="dashboard-preview "
            style={{ paddingTop: 0, height: "unset", width: "100%" }}>
            <div
              className="progress-pages row"
              style={{ margin: 0 }}
              onClick={this.onGeneralClicked.bind(this)}>
              <div className="col-md-1 ">
                <img
                  style={{ marginTop: "6px" }}
                  src="../../style/images/cheklisticons/checkmark.svg"
                  alt="checkmark"
                />
              </div>
              <div className="col-md-1">
                <div className="checklist-icons">
                  <img
                    className="checklist-svgicons"
                    src="../../style/images/cheklisticons/checklist-general.svg"
                    alt="checklist-general"
                  />
                </div>
              </div>
              <div className="col-md-10 checklist-content-column">
                <p
                  className="checklist-headertext"
                  style={{ marginBottom: "1px" }}>
                  {LocaleStrings.dashboard_checklist_general_text}
                </p>
                <p className="checklist-subheadertext">
                  {LocaleStrings.dashboard_checklist_general_subtext}
                </p>
              </div>
            </div>
            <hr style={{ margin: 0 }} />
            <div
              className="progress-pages row"
              style={{ margin: 0, marginTop: "9px" }}
              onClick={this.onBrandingClicked.bind(this)}>
              <div className="col-md-1 ">
                {branding === true ? (
                  <img
                    style={{ marginTop: "6px" }}
                    src="../../style/images/cheklisticons/checkmark.svg"
                    alt="checkmark"
                  />
                ) : (
                  <i
                    className="fa fa-exclamation-circle"
                    style={{
                      color: "red",
                      fontSize: "20px",
                      paddingTop: "10px",
                      paddingLeft: "3px",
                    }}
                  />
                )}
              </div>
              <div className="col-md-1">
                <div className="checklist-icons">
                  <img
                    className="checklist-svgicons"
                    src="../../style/images/cheklisticons/checklist-branding.svg"
                    alt="checklist-branding"
                  />
                </div>
              </div>
              <div className="col-md-10 checklist-content-column">
                <p
                  className="checklist-headertext"
                  style={{ marginBottom: "1px" }}>
                  {LocaleStrings.dashboard_checklist_branding_text}
                </p>
                <p className="checklist-subheadertext">
                  {LocaleStrings.dashboard_checklist_branding_subtext}
                </p>
              </div>
            </div>
            <hr style={{ margin: 0 }} />
            <div
              className="progress-pages row"
              style={{ margin: 0, marginTop: "9px" }}
              onClick={this.onContentClicked.bind(this)}>
              <div className="col-md-1 ">
                {content === true ? (
                  <img
                    style={{ marginTop: "6px" }}
                    src="../../style/images/cheklisticons/checkmark.svg"
                    alt="checkmark"
                  />
                ) : (
                  <i
                    className="fa fa-exclamation-circle"
                    style={{
                      color: "red",
                      fontSize: "20px",
                      paddingTop: "10px",
                      paddingLeft: "3px",
                    }}
                  />
                )}
              </div>
              <div className="col-md-1">
                <div className="checklist-icons">
                  <img
                    className="checklist-svgicons"
                    src="../../style/images/cheklisticons/checklist-content.svg"
                    alt="checklist-content"
                  />
                </div>
              </div>
              <div className="col-md-10 checklist-content-column">
                <p
                  className="checklist-headertext"
                  style={{ marginBottom: "1px" }}>
                  {LocaleStrings.dashboard_checklist_content_text}
                </p>
                <p className="checklist-subheadertext">
                  {LocaleStrings.dashboard_checklist_content_subtext}
                </p>
              </div>
            </div>
            <hr style={{ margin: 0 }} />
            <div
              className="progress-pages row"
              style={{ margin: 0, marginTop: "9px" }}
              onClick={this.onUserSettingClicked.bind(this)}>
              <div className="col-md-1 ">
                {setting === true ? (
                  <img
                    style={{ marginTop: "6px" }}
                    src="../../style/images/cheklisticons/checkmark.svg"
                    alt="checkmark"
                  />
                ) : (
                  <i
                    className="fa fa-exclamation-circle"
                    style={{
                      color: "red",
                      fontSize: "20px",
                      paddingTop: "10px",
                      paddingLeft: "3px",
                    }}
                  />
                )}
              </div>
              <div className="col-md-1">
                <div className="checklist-icons">
                  <img
                    className="checklist-svgicons"
                    src="../../style/images/cheklisticons/checklist-settings.svg"
                    alt="checklist-settings"
                  />
                </div>
              </div>
              <div className="col-md-10 checklist-content-column">
                <p
                  className="checklist-headertext"
                  style={{ marginBottom: "1px" }}>
                  {LocaleStrings.dashboard_checklist_settings_text}
                </p>
                <p className="checklist-subheadertext">
                  {LocaleStrings.dashboard_checklist_settings_subtext}
                </p>
              </div>
            </div>
            <hr style={{ margin: 0 }} />
            {enabledTicket.length > 0 ? (
              <div
                className="progress-pages row"
                style={{ margin: 0, marginTop: "9px" }}
                onClick={this.onPaymentGatewayClicked.bind(this)}>
                <div className="col-md-1">
                  {paymentgateway === true ? (
                    <img
                      style={{ marginTop: "6px" }}
                      src="../../style/images/cheklisticons/checkmark.svg"
                      alt="checkmark"
                    />
                  ) : (
                    <i
                      className="fa fa-exclamation-circle"
                      style={{
                        color: "red",
                        fontSize: "20px",
                        paddingTop: "10px",
                        paddingLeft: "3px",
                      }}
                    />
                  )}
                </div>
                <div className="col-md-1">
                  <div className="checklist-icons">
                    <img
                      className="checklist-svgicons"
                      src="../../style/images/cheklisticons/checklist-payment.svg"
                      alt="checklist-payment"
                    />
                  </div>
                </div>
                <div className="col-md-10 checklist-content-column">
                  <p
                    className="checklist-headertext"
                    style={{ marginBottom: "1px" }}>
                    {LocaleStrings.dashboard_checklist_payment_text}
                  </p>
                  <p className="checklist-subheadertext">
                    {LocaleStrings.dashboard_checklist_payment_subtext}
                  </p>
                </div>
              </div>
            ) : (
              ""
            )}
            <div className="support-checklist">
              <div className="pull-left" style={{ display: "flex" }}>
                <img
                  className="checklist-svgicons"
                  style={{ marginRight: 10 }}
                  src="../../style/images/cheklisticons/question.svg"
                  alt="question"
                />
                <span className="need-help-text">
                  Need more help setting up Eventify?
                </span>
              </div>
              <div className="pull-right">
                <a href="https://eventify.io/contactus/" target="_blank">
                  <button className="btn checklist-contactsupport">
                    Contact Support
                  </button>
                </a>
              </div>
            </div>
          </div>
        </PopoverBody>
      </Popover>
    );
  };

  chooseEvent = () => {
    this.props.initiateCreateEvent({ initiate: false });
    this.props.openEventChooser({ showModal: true });
  };

  createNewEvent = () => {
    confirmAlert({
      title: LocaleStrings.new_event_title_create_new_event,
      message: LocaleStrings.new_event_text_sure_want_to_create_event,
      confirmLabel: LocaleStrings.button_ok,
      cancelLabel: LocaleStrings.button_cancel,
      buttons: [
        {
          label: LocaleStrings.button_ok,
          onClick: () => {
            this.props.initiateCreateEvent({ initiate: true });
            this.props.openEventChooser({ showModal: true });
          },
        },
        {
          label: LocaleStrings.button_cancel,
          onClick: () => {},
        },
      ],
    });
  };

  cloneThisEvent = () => {
    confirmAlert({
      title: LocaleStrings.clone_event_title_clone_this_event,
      message: LocaleStrings.clone_event_text_sure_want_to_clone_event,
      confirmLabel: LocaleStrings.button_ok,
      cancelLabel: LocaleStrings.button_cancel,
      // onConfirm: () => {
      //   this.props.openCloneOptions({ showModal: true });
      // },
      // onCancel: () => {},
      buttons: [
        {
          label: LocaleStrings.button_ok,
          onClick: () => {
            this.props.openCloneOptions({ showModal: true });
          },
        },
        {
          label: LocaleStrings.button_cancel,
          onClick: () => {},
        },
      ],
    });
  };

  optionSelect = (e) => {
    if (e === "create") {
      this.createNewEvent();
    } else {
      this.cloneThisEvent();
    }
  };

  onFeaturesClicked() {
    var menuItem = {
      iconName: "Features",
      bsClass: "features",
      description: "Add a new feature to your event app.",
    };
    this.props.selectDashboardMenu(menuItem);
    this.props.history.push("/dashboard/features");
  }

  onGeneralClicked() {
    var menuItem = {
      iconName: "General",
      bsClass: "general",
      description: "General information about your app and event.",
    };
    this.props.selectDashboardMenu(menuItem);
    this.props.history.push("/dashboard");
    this.closeprogressPreviewPop();
  }

  onBrandingClicked() {
    var menuItem = {
      iconName: "Branding",
      bsClass: "branding",
      description:
        "Customize your app look and feel that matches with your brand.",
    };
    this.props.selectDashboardMenu(menuItem);
    this.props.history.push("/dashboard/branding/appbranding");
    this.closeprogressPreviewPop();
  }

  onContentClicked() {
    var menuItem = {
      iconName: "Content",
      bsClass: "content",
      description: "Manage, add or remove your app contents.",
    };
    this.props.selectDashboardMenu(menuItem);
    this.props.history.push("/dashboard/content");
    this.closeprogressPreviewPop();
  }

  onUserSettingClicked() {
    var menuItem = {
      iconName: "Tickets",
      bsClass: "tickets",
      description: "Manage registration of users for the event.",
    };
    this.props.selectDashboardMenu(menuItem);
    this.props.history.push("/dashboard/tickets/settings");
    this.closeprogressPreviewPop();
  }

  onPaymentGatewayClicked() {
    var menuItem = {
      iconName: "Tickets",
      bsClass: "tickets",
      description: "Manage registration of users for the event.",
    };
    this.props.selectDashboardMenu(menuItem);
    this.props.history.push("/dashboard/tickets/dashboard");
    this.closeprogressPreviewPop();
  }

  render() {
    let {
      totalAppModules,
      contentDashboard,
      availableFeatures,
      ticketDashboard,
      user,
      hidePreviewAndFooter,
      hideOnlyPreview,
    } = this.props;
    var enabledTicket = 0;
    // console.log("user :- ", user);

    enabledTicket = _.filter(totalAppModules, {
      bsClass: "tickets",
      isenabled: true,
    });

    let content = true;
    _.map(availableFeatures, (feature) => {
      if (feature.isenabled) {
        if (contentDashboard && !contentDashboard[feature.bsClass]) {
          content = false;
        }
      }
    });
    let branding = true;
    if (ticketDashboard !== undefined && ticketDashboard.branding === false) {
      branding = false;
    }
    let setting = true;
    if (ticketDashboard !== undefined && ticketDashboard.setting === false) {
      setting = false;
    }
    let paymentgateway = true;
    if (
      ticketDashboard !== undefined &&
      ticketDashboard.paymentgateway === false
    ) {
      paymentgateway = false;
    }
    let general = true;
    var progressArr = [];
    progressArr.push(content);
    progressArr.push(general);
    progressArr.push(branding);
    progressArr.push(setting);
    if (enabledTicket.length !== 0) {
      progressArr.push(paymentgateway);
    }

    let counts = {};
    progressArr.forEach(function (x) {
      counts[x] = (counts[x] || 0) + 1;
    });

    var option1 = 0;
    var progressPercentage = 0;

    if (enabledTicket.length !== 1) {
      if (counts.true === 4) {
        option1 = 100;
        progressPercentage = 100;
      } else if (counts.false === 1) {
        option1 = 75;
        progressPercentage = 75;
      } else if (counts.false === 2) {
        option1 = 50;
        progressPercentage = 50;
      } else if (counts.false === 3) {
        option1 = 25;
        progressPercentage = 25;
      } else if (counts.false === 4) {
        option1 = 0;
        progressPercentage = 0;
      }
    } else {
      if (counts.true === 5) {
        option1 = 100;
        progressPercentage = 100;
      } else if (counts.false === 1) {
        option1 = 80;
        progressPercentage = 80;
      } else if (counts.false === 2) {
        option1 = 60;
        progressPercentage = 60;
      } else if (counts.false === 3) {
        option1 = 40;
        progressPercentage = 40;
      } else if (counts.false === 4) {
        option1 = 20;
        progressPercentage = 20;
      } else if (counts.false === 5) {
        option1 = 0;
        progressPercentage = 0;
      }
    }

    var bottombarWidth = window.innerWidth - (isTablet ? 0 : 320);
    // var footerStyle={display:'block', width:bottombarWidth};
    var footerStyle = {
      display: "block",
      width: window.innerWidth - (isTablet ? 60 : 70),
    };

    if (this.props.hideOnlyFooter || this.props.hidePreviewAndFooter) {
      footerStyle.display = "none";
    }

    if (this.props.hideOnlyPreview) {
      footerStyle.display = "block";
    }

    var inlineStyle = {
      top: 70,
    };

    let height = "auto";

    let supportStatus = _.filter(totalAppModules, (o) => {
      return o.bsClass === "support" && o.isenabled === true;
    });

    var style = {
      width: "34px",
      height: "32px",
      marginLeft: "15px",
      borderRadius: "50%",
      // marginRight: "15px"
    };

    var profileurl = "";
    var name = "";
    var email = "";

    if (
      this.props.loggedinuserData &&
      this.props.loggedinuserData.data &&
      this.props.loggedinuserData.data.length > 0
    ) {
      if (
        !this.props.loggedinuserData?.data[0]?.profileurl == "" &&
        !this.props.loggedinuserData?.data[0]?.profileurl == null
      ) {
        profileurl = `${BASE_IMAGES_URL}/${this.props.loggedinuserData.data[0].profileurl}?api_key=${this.props.session.apiKey}&session_token=${this.props.session.sessionToken}`;
      }
      name = this.props.loggedinuserData.data[0].username;
      email = this.props.loggedinuserData.data[0].email;
    }

    let openissuecount = 0;

    if (
      this.props.adminissueListopen &&
      this.props.adminissueListopen.length > 0
    ) {
      openissuecount = this.props.adminissueListopen.length;
    }

    return (
      <div className="h-100">
        <div className="dashboard-menu menu-animation">
          <ul className="static-icon">{this.renderLogoMenuIcon()}</ul>
          <ul className="menu-icons" style={inlineStyle}>
            {this.renderMenuIcons()}
          </ul>
        </div>
        <div className="dashboard-navbar pull-top nav-animation">
          <div className="warp-header-icon">
            <div className="nav-bar-subtitle main-header-left-section content-fadein-animation">
              <div className="nav-bar-subtitle-title">
                {this.props.selectedMenu.bsClass === "tickets"
                  ? "User Management"
                  : this.props.selectedMenu.iconName}

                {this.props.selectedMenu.bsClass === "accountsettings" ? (
                  <span className="ps-1">
                    <BetaFeature />
                  </span>
                ) : (
                  ""
                )}
              </div>
              <div className="nav-bar-subtitle-desc">
                {this.props.selectedMenu.bsClass === "tickets"
                  ? "Manage users for the event."
                  : this.props.selectedMenu.description}
              </div>
            </div>

            <div className="main-header-right-section">
              {DEVELOPMENT_TYPE === "eventify" && user.totalAdminEvents > 0 ? (
                <OverlayTrigger
                  trigger="click"
                  placement="bottom"
                  rootClose
                  // ref="progressPreviewPop"
                  overlay={this.progressPreview()}>
                  <span className="progressbar-container">
                    <span
                      className="progress-text"
                      style={{ paddingRight: "10px" }}>
                      {LocaleStrings.progress}
                    </span>

                    <ProgressBar
                      now={option1}
                      className="progress-main-header"
                    />
                    <span style={{ paddingLeft: "10px" }}>
                      {progressPercentage}%
                    </span>
                    <i
                      className="fa fa-caret-down"
                      aria-hidden="true"
                      style={{ paddingLeft: "10px", paddingRight: "10px" }}></i>
                  </span>
                </OverlayTrigger>
              ) : (
                ""
              )}
              {DEVELOPMENT_TYPE === "eventify" && user && user.isSuperAdmin ? (
                <Button
                  type="button"
                  className="btn btn-custom-white toolitp-btn"
                  onClick={this.onSupportChatIconClicked.bind(this)}>
                  <div style={{ display: "flex" }}>
                    {LocaleStrings.button_raise_ticket}
                    <img
                      className="header-menu-supportchat-icon ml-2"
                      src="../../style/images/cheklisticons/managereport.svg"
                      alt="support-chat-icon"
                    />
                    {openissuecount > 0 ? (
                      <span
                        className="unread-count"
                        aria-hidden="true"
                        style={{ left: "116px" }}>
                        {openissuecount}
                      </span>
                    ) : (
                      ""
                    )}
                  </div>
                </Button>
              ) : (
                ""
              )}

              {/* <OverlayTrigger   
                    trigger="click"
                    placement="bottom"
                    // rootClose={true}
                    ref="publishPop"
                    overlay={ this.publishPopover() }
                  >
                    <Button type="button" className="btn btn-primary" style={{margin: '0px 0px 0px 20px'}}>{LocaleStrings.button_upgrade}</Button>
                  </OverlayTrigger> */}

              {DEVELOPMENT_TYPE === "eventify" && user.totalAdminEvents > 0 ? (
                <OverlayTrigger
                  trigger="click"
                  placement="bottom"
                  rootClose
                  // ref="eventInfoPop"
                  overlay={this.basicEventInfo()}>
                  <Button
                    type="button"
                    className="btn btn-custom-white toolitp-btn"
                    style={{ borderColor: "#fff" }}>
                    <div style={{ display: "flex" }}>
                      <img
                        className="phone-preview"
                        src="../../style/images/cheklisticons/eventinfo.svg"
                        alt="eventinfo"
                      />
                    </div>
                    <span className="tooltiptext-dashboard-top">
                      {LocaleStrings.event_basic_info}
                    </span>
                  </Button>
                </OverlayTrigger>
              ) : (
                ""
              )}

              {DEVELOPMENT_TYPE === "eventify" && user.totalAdminEvents > 0 ? (
                <OverlayTrigger
                  trigger="click"
                  placement="bottom"
                  rootClose
                  // ref="mobilePreviewPop"
                  overlay={this.mobilePreview()}>
                  <Button
                    type="button"
                    className="btn btn-custom-white toolitp-btn"
                    style={{ borderColor: "#fff" }}>
                    <div style={{ display: "flex" }}>
                      <img
                        className="phone-preview"
                        src="../../style/images/cheklisticons/phone-preview.svg"
                        alt="phone-preview"
                      />
                    </div>
                    <span className="tooltiptext-dashboard-top">
                      {LocaleStrings.phone_preview}
                    </span>
                  </Button>
                </OverlayTrigger>
              ) : (
                ""
              )}

              {/* SETTINGS AND LOGOUT BUTTON COMMENTED FOR NEW DESIGN ON 01/03/22 */}

              {/* <span className="accountbutton"> */}
              <div className="dropdown-btn-container">
                <DropdownButton
                  className="dropdown-white-btn-dashboard"
                  // title={"Account"}
                  title={
                    profileurl !== "" ? (
                      <>
                        <img
                          src={profileurl}
                          className="admin-profilie-image"
                          alt="admin-profilie-image"
                        />
                        Account
                      </>
                    ) : (
                      <>
                        <img
                          src="../../style/images/custom-icons/user_2.png"
                          alt="admin-profilie-image"
                          className="admin-profilie-image"
                        />
                        Account
                      </>
                    )
                  }
                  key="1"
                  id="dropdown-account-dropdown"
                  nocaret="true">
                  <div className="d-flex gap-1 p-1">
                    <div>
                      {profileurl !== "" ? (
                        <img
                          src={profileurl}
                          className="admin-profilie-image"
                          alt="admin-profilie-image"
                        />
                      ) : (
                        <img
                          src="../../style/images/custom-icons/user_2.png"
                          alt="admin-profilie-image"
                          className="admin-profilie-image"
                        />
                      )}
                    </div>
                    <div>
                      <div>{name}</div>
                      <div className="dashboard-dropdown-email">{email}</div>
                    </div>
                  </div>
                  <hr className="dashboard-hr" />
                  {DEVELOPMENT_TYPE === "eventify" &&
                  user &&
                  user.isSuperAdmin &&
                  (user.allowedEvent < 0 ||
                    user.allowedEvent > user.totalCreatedEvents) ? (
                    <Dropdown.Item
                      eventKey="createevent"
                      style={{
                        paddingBottom: "10px",
                        fontSize: "14px",
                        paddingTop: "8px",
                      }}
                      onClick={() => this.createNewEvent("createevent")}>
                      <img
                        className="account-setting-icons"
                        src="../../style/images/cheklisticons/newevent.svg"
                        alt="newevent"
                      />
                      {LocaleStrings.button_new_event}
                    </Dropdown.Item>
                  ) : (
                    ""
                  )}
                  {DEVELOPMENT_TYPE === "eventify" &&
                  user &&
                  user.allowedEvent !== 1 ? (
                    <Dropdown.Item
                      eventKey="manageevent"
                      style={{ paddingBottom: "10px", fontSize: "14px" }}
                      onClick={() => this.chooseEvent("manageevent")}>
                      <img
                        className="account-setting-icons"
                        src="../../style/images/cheklisticons/manageevent.svg"
                        alt="manageevent"
                      />
                      {LocaleStrings.button_manage_event}
                    </Dropdown.Item>
                  ) : (
                    ""
                  )}
                  {/* currently seetings added into the side menu */}
                  {/* <Dropdown.Item
                      eventKey="settings"
                      style={{ paddingBottom: "10px", fontSize: "14px" }}
                      onClick={() => this.onSettingsClicked("settings")}
                    >
                      <img
                        className="account-setting-icons"
                        style={{ height: "20px", marginRight: "6px" }}
                        src="../../style/images/cheklisticons/mainsetting.svg"
                        alt="mainsetting"
                      />
                      Settings
                    </Dropdown.Item> */}
                  {/* Comment For Hub update */}
                  {DEVELOPMENT_TYPE === "eventify" &&
                  user &&
                  user.isSuperAdmin ? (
                    <Dropdown.Item
                      eventKey="settings"
                      style={{
                        paddingBottom: "10px",
                        fontSize: "14px",
                        paddingLeft: "14px",
                      }}
                      onClick={() =>
                        this.onAccountSettingsClicked("accountsettings")
                      }>
                      <img
                        className="account-setting-icons"
                        style={{ height: "18px", marginRight: "8px" }}
                        src="../../style/images/cheklisticons/accountsettings.svg"
                        alt="mainsetting"
                      />
                      {LocaleStrings.button_my_account}
                      <span className="ps-1">
                        <BetaFeature />
                      </span>
                    </Dropdown.Item>
                  ) : (
                    ""
                  )}
                  <hr style={{ margin: 0, height: "0.5px" }} />
                  <Dropdown.Item
                    eventKey="logout"
                    style={{
                      paddingBottom: "10px",
                      fontSize: "14px",
                      paddingLeft: "14px",
                    }}
                    onClick={() => this.onLogoutClicked("logout")}>
                    <img
                      className="account-setting-icons"
                      style={{ height: "20px", marginRight: "6px" }}
                      src="../../style/images/cheklisticons/logout.svg"
                      alt="logout"
                    />
                    Logout
                  </Dropdown.Item>
                </DropdownButton>
              </div>
              {/* </span> */}
              {/* <div style={style}></div> */}

              {/* <div className="d-flex justify-content-end">
              </div> */}
            </div>
          </div>
        </div>

        <div
          className="dashboard-content content-fadein-animation "
          style={{
            float: "left",
            height: `100vh`,
          }}>
          <Route
            path="/dashboard/content"
            history={this.props.history}
            component={Content}
          />
          <Route
            path="/dashboard/branding"
            render={(props) => (
              <Branding
                submitBrandingDataHandler={this.submitBrandingDataCallback.bind(
                  this
                )}
                ref={this.brandingRef}
                history={this.props.history}
              />
            )}
          />
          <Route path="/dashboard/outreach" component={DashboardOutreach} />
          <Route
            path="/dashboard/users"
            component={(props) => Users}
            history={this.props.history}
          />
          <Route
            path="/dashboard/features"
            render={(props) => (
              <FeaturesPage
                submitFeaturesDataHandler={this.submitFeaturesDataCallback.bind(
                  this
                )}
                ref={this.featureRef}
              />
            )}
          />
          <Route
            path="/dashboard/userlimitexpired"
            component={UserlimitExpired}
            history={this.props.history}
          />
          <Route path="/dashboard/activity" component={Activity} />
          <Route path="/dashboard/analytics" component={Analytics} />
          <Route path="/dashboard/settings" component={Settings} />
          <Route
            path="/dashboard/accountsettings"
            component={Accountsettings}
          />

          <Route path="/dashboard/support" component={Supportchat} />

          <Route path="/dashboard/website" component={Templates} />
          <Route
            path="/dashboard/tickets"
            history={this.props.history}
            component={Tickets}
          />
          <Route
            path="/dashboard/polls"
            history={this.props.history}
            component={Polls}
          />
          <Route
            path="/dashboard/gamification"
            history={this.props.history}
            component={Gamification}
          />

          <Route
            path="/dashboard/general"
            render={(props) => (
              <General
                history={this.props.history}
                submitSettingsHandler={this.submitSettingsCallback.bind(this)}
                ref={this.generalRef}
              />
            )}
          />
          <Route path="/dashboard/reportissue" component={ReportIssue} />
          <Route path="/dashboard/notification" component={Notification} />
          <Route path="/dashboard/message" component={Message} />
          <Route path="/dashboard/profile" component={Profile} />
          <Route path="/dashboard/hsettings" component={HeaderSettings} />
          <Route path="/dashboard/upload" component={FileUpload} />
          <Route
            exact
            path="/dashboard"
            render={(props) => (
              <General
                history={this.props.history}
                submitSettingsHandler={this.submitSettingsCallback.bind(this)}
                ref={this.generalRef}
              />
            )}
          />

          {DEVELOPMENT_TYPE === "koachify" ? (
            <Route path="/dashboard/courses" component={(props) => Courses} />
          ) : (
            ""
          )}

          <div
            className="dashboard-bottombar navbar-fixed-bottom"
            style={footerStyle}>
            {/* <div
              className="bottom-container"
              style={{ paddingRight: 20, width: isTablet ? "100%" : "66%" }}
            >
            </div> */}
            <Row>
              <Col sm={4} md={6}>
                {/* {this.props.isProcessing ? (
                  <div className="bottom-unsaved">
                    {LocaleStrings.saving_changes}...
                  </div>
                ) : this.props.unsavedChanges ? (
                  <div className="bottom-unsaved">
                    <span className="dot"></span>
                    {"  "}
                    {LocaleStrings.you_have_changes}
                  </div>
                ) : null} */}
              </Col>

              <Col className="bottombar-tab" sm={8} md={6}>
                <div className="pull-left- bottom-buttons">
                  {this.props.isProcessing ? (
                    <div className="bottom-unsaved">
                      <span className="" style={{ marginRight: 15 }}>
                        {LocaleStrings.saving_changes}...
                      </span>
                    </div>
                  ) : this.props.unsavedChanges ? (
                    <div className="bottom-unsaved">
                      <span className="dot"></span>
                      {"  "}
                      <span className="" style={{ marginRight: 15 }}>
                        {LocaleStrings.you_have_changes}
                      </span>
                    </div>
                  ) : null}
                  <Button
                    className="bottombar-save-button btn-custom-blue"
                    loading={this.state.loadingSave}
                    type="button"
                    onClick={this.onlySave}>
                    {LocaleStrings.button_save}
                  </Button>
                  <Button
                    className="bottombar-saveandnext-button btn-custom-blue"
                    loading={this.state.loading}
                    type="button"
                    onClick={this.goNext}>
                    {LocaleStrings.button_save_next}
                  </Button>
                </div>
              </Col>
            </Row>
          </div>
        </div>
        {hidePreviewAndFooter || hideOnlyPreview || isTablet ? null : ""}
        <ErrorBar />
        <EventChooser insideDashBoard={true} history={this.props.history} />

        {this.props.showEventCloneModal === true ? <EventClone /> : ""}
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  //debugger;
  var eventData = state.eventData[0];
  var selectedMenu = state.selectedMenu;
  if (ownProps.location.pathname === "/dashboard") {
    var generalMenuItem = state.appicons[0];
    selectedMenu = generalMenuItem;
  }

  var hidePreviewAndFooter =
    ownProps.location.pathname === "/dashboard/publish" ||
    ownProps.location.pathname === "/dashboard/analytics" ||
    _.includes(ownProps.location.pathname, "/dashboard/analytics/") ||
    ownProps.location.pathname === "/dashboard/settings" ||
    _.includes(ownProps.location.pathname, "/dashboard/settings/") ||
    _.includes(ownProps.location.pathname, "/dashboard/accountsettings/") ||
    _.includes(ownProps.location.pathname, "/dashboard/reportissue") ||
    _.includes(ownProps.location.pathname, "/dashboard/userlimitexpired") ||
    _.includes(ownProps.location.pathname, "/dashboard/support") ||
    _.includes(ownProps.location.pathname, "/dashboard/website") ||
    _.includes(ownProps.location.pathname, "/dashboard/website/") ||
    _.includes(ownProps.location.pathname, "/dashboard/tickets") ||
    ownProps.location.pathname === "/dashboard/content/tickets" ||
    _.includes(ownProps.location.pathname, "/dashboard/proposal/") ||
    _.includes(ownProps.location.pathname, "/dashboard/courses") ||
    _.includes(ownProps.location.pathname, "/dashboard/courses/") ||
    _.includes(ownProps.location.pathname, "/dashboard/gamification") ||
    _.includes(ownProps.location.pathname, "/dashboard/gamification/");

  var hideOnlyFooter =
    _.includes(ownProps.location.pathname, "/dashboard/content/") ||
    _.includes(ownProps.location.pathname, "/dashboard/content") ||
    ownProps.location.pathname === "/dashboard/users" ||
    ownProps.location.pathname === "/dashboard/outreach" ||
    _.includes(ownProps.location.pathname, "/dashboard/polls/") ||
    _.includes(ownProps.location.pathname, "/dashboard/polls");

  var hideOnlyPreview =
    _.includes(ownProps.location.pathname, "/dashboard/branding") ||
    _.includes(ownProps.location.pathname, "/dashboard/features");

  var currentPage = "";
  if (
    _.includes(ownProps.location.pathname, "/dashboard/general") ||
    ownProps.location.pathname === "/dashboard"
  ) {
    currentPage = "general";
  } else if (_.includes(ownProps.location.pathname, "/dashboard/branding")) {
    currentPage = "branding";
  } else if (_.includes(ownProps.location.pathname, "/dashboard/features")) {
    currentPage = "features";
  } else {
    currentPage = "";
  }

  var skip = hidePreviewAndFooter || hideOnlyPreview;

  return {
    createEventFromDashboard: state.createEventFromDashboard,
    menuIcons: state.appicons,
    selectedMenu: selectedMenu,
    isLoggedIn: state.isLoggedIn,
    session: state.session,
    hidePreviewAndFooter,
    hideOnlyFooter,
    hideOnlyPreview,
    currentPage,
    unsavedChanges: state.unsavedChanges,
    user: state.user,
    isProcessing: state.processing,
    skipWidthCalculation: skip,
    selectedRevealIcon: state.selectedRevealMenu,
    totalAppModules: state.totalAppModules,
    currentEventData: eventData,
    showEventCloneModal: state.showEventCloneModal,
    availableFeatures: state.availableFeatures.filter(
      (feature) => feature.available
    ),
    ticketDashboard: state.ticketDashboard ? state.ticketDashboard.data : {},
    contentDashboard: state.contentDashboard ? state.contentDashboard.data : {},
    unreadcount: _.isEmpty(state.unreadcount) ? 0 : parseInt(state.unreadcount),
    loggedinuserData: state.loggedinuserData,
    adminissueListopen: state.adminissueListopen,
    clientdataforbilling: state.clientdataforbilling,
    total_accountusageCount: state.total_accountusageCount,
  };
}

export default connect(
  mapStateToProps,
  {
    initiateCreateEvent,
    openEventChooser,
    fetchAllRelatedEvents,
    selectedRevealMenuIcon,
    selectDashboardMenu,
    logout,
    createEventInsideDashboard,
    fetchBranding,
    fetchBrandingEmpty,
    updateUnsavedChanges,
    fetchScheduleDates,
    dateRangeUpdate,
    patchEventDetails,
    showError,
    showSuccess,
    uploadBrandingData,
    patchFeatures,
    fetchFeature,
    updateProcessing,
    checkTicketDaschoardStatus,
    checkContentDashboardStatus,
    openCloneOptions,
    fetchEvent,
    fetchUnreadcount,
    updateEmailtemplateswiththemecolor,
    fetchLoggedinuser,
    fetchadminissueTokenOpen,
    fetchtotalaccountusageofclient,
    fetchClientalldetails,
    resetAppmodules,
    checkClientExpiryDate,
    markLogin,
    getDeviceSize,
  },
  null,
  { forwardRef: true }
)(Dashboard);
